// eslint-disable-next-line import/prefer-default-export
export const locales = [
  {
    locale: 'en',
    // eslint-disable-next-line global-require
    img: require('@/assets/images/flags2/en.png'),
    name: 'English',
  },
  {
    locale: 'tr',
    // eslint-disable-next-line global-require
    img: require('@/assets/images/flags2/TR.png'),
    name: 'Türkçe',
  },
  {
    locale: 'de',
    // eslint-disable-next-line global-require
    img: require('@/assets/images/flags2/de.png'),
    name: 'Deutsch',
  },
  {
    locale: 'es',
    // eslint-disable-next-line global-require
    img: require('@/assets/images/flags2/es.png'),
    name: 'Español',
  },
  {
    locale: 'pt',
    // eslint-disable-next-line global-require
    img: require('@/assets/images/flags2/pt.png'),
    name: 'Português',
  },
  {
    locale: 'fr',
    // eslint-disable-next-line global-require
    img: require('@/assets/images/flags2/fr.png'),
    name: 'Francês',
  },
  {
    locale: 'ru',
    // eslint-disable-next-line global-require
    img: require('@/assets/images/flags2/ru.png'),
    name: 'Русский',
  },
  {
    locale: 'ua',
    // eslint-disable-next-line global-require
    img: require('@/assets/images/flags2/ua.png'),
    name: 'Українська',
  },
  {
    locale: 'ar',
    // eslint-disable-next-line global-require
    img: require('@/assets/images/flags2/sa.png'),
    name: 'عربي',
  },
]
